import React from "react";
import { Link } from "react-router-dom";

export default function Blog({ blog }) {
  const { likes, isSaved, title, image, tags, createdAt, id } = blog;

  return (
    <div className="lws-card">
      <Link to={`/post/${id}`}>
        <img src={image} className="lws-card-image" alt={title} />
      </Link>
      <div className="p-4">
        <div className="lws-card-header">
          <p className="lws-publishedDate">{createdAt}</p>
          <p className="lws-likeCount">
            <i className="fa-regular fa-thumbs-up"></i>
            {likes}
          </p>
        </div>
        <Link to={`/post/${id}`} className="lws-postTitle">
          {title}
        </Link>
        <div className="lws-tags">
          {tags?.map((tag, i) => {
            // if its the last tag then dont' add comma
            if (tags.length === i + 1) {
              return <span key={i}>#{tag} </span>;
            } else {
              return <span key={i}>#{tag + ","} </span>;
            }
          })}
        </div>

        <div className="flex gap-2 mt-4">
          {isSaved && <span className="lws-badge"> Saved </span>}
        </div>
      </div>
    </div>
  );
}
